import Swal from "sweetalert2";
import { useState } from "react";
import Modals from "./FinancialTabsModals";
import { deleteTransaction } from "services/FinancialDepartment";
import { updateRecord } from "services/services";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
export default function FinancialTabs({ transactionList1, transactionList2, transactionList3, updater, userList, transactionListAll }) {
  const [selectedCardInformation, setSelectedCardInformation] = useState({ date: "1400/11/14", id: "10", price: "100000", type: "2", user: { fullname: "مریم مریم", walletId: "1" }, transactionId: 1 });
  const [searchValue, setSearchValue] = useState("");

  const setCurrentTransactionInModal = (value) => {
    if (value.type == 2) {
      setSelectedCardInformation({ date: value.date, price: value.price, type: value.type, transactionId: value.id, fromWalletId: { value: value.fromUser.walletId, label: value.fromUser.fullname }, toWalletId: { value: value.toUser.walletId, label: value.toUser.fullname } });
    } else {
      setSelectedCardInformation({ date: value.date, price: value.price, type: value.type, transactionId: value.id, fromWalletId: { value: value.user.walletId, label: value.user.fullname }, toWalletId: { value: null, label: null } });
    }
  };

  function search1(value) {
    setSearchValue(value);
  }
  function searchResult(value, component) {
    if (value.user?.fullname.includes(searchValue) || value.price.includes(searchValue) || value.date.includes(searchValue) || value.time.includes(searchValue) || +value.type == searchValue) {
      return component;
    } else {
      return null;
    }
  }
  return (
    <div className="financial-tabs-container">
      <Modals editInformation={selectedCardInformation} userList={userList} updater={updater}></Modals>
      <Searchbox search1={search1}></Searchbox>

      <div>
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button className="nav-link active  " id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#darkhast-bardasht" type="button" role="tab" aria-controls="pills-home" aria-selected="true">
              درخواست های برداشت
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#tarakonesh-dakheli" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
              تراکنش های داخلی
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#varizihaye-anjam-shodeh" type="button">
              واریزی های انجام شده
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#hame-tarakoneshha" type="button">
              همه تراکنش ها
            </button>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
          <div className="tab-pane fade show active" id="darkhast-bardasht" role="tabpanel">
            <div></div>
            {transactionList3.map((value) => {
              return searchResult(value, <CardItem setCurrentTransactionInModal={setCurrentTransactionInModal} information={value} updater={updater}></CardItem>);
            })}
          </div>
          <div className="tab-pane fade" id="tarakonesh-dakheli" role="tabpanel">
            {transactionList2.map((value) => {
              return searchResult(value, <CardItem setCurrentTransactionInModal={setCurrentTransactionInModal} information={value} updater={updater}></CardItem>);
            })}
          </div>
          <div className="tab-pane fade" id="varizihaye-anjam-shodeh" role="tabpanel" aria-labelledby="pills-contact-tab">
            {transactionList1.map((value) => {
              return searchResult(value, <CardItem setCurrentTransactionInModal={setCurrentTransactionInModal} information={value} updater={updater}></CardItem>);
            })}
          </div>
          <div className="tab-pane fade" id="hame-tarakoneshha" role="tabpanel" aria-labelledby="pills-contact-tab">
            <div className="d-flex justify-content-between flex-wrap">
              <div className="me-4 mt-3" data-bs-toggle="modal" data-bs-target="#add-card-item">
                <button className="btn btn-purple">+ افزودن تراکنش</button>
              </div>
            </div>
            {transactionListAll.map((value) => {
              return searchResult(value, <CardItem setCurrentTransactionInModal={setCurrentTransactionInModal} information={value} updater={updater}></CardItem>);
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export function CardItem({ information, updater, setCurrentTransactionInModal }) {
  function deleteCard(transactionId, type) {
    Swal.fire({
      title: "آیتم مد نظر حذف شود؟",
      text: "این اقدام قابل بازیابی نیست",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "پاک شود",
      cancelButtonText: "انصراف",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteTransaction(transactionId, type).then((value) => {
          if (value) {
            Swal.fire("آیتم مد نظر پاک شد.");
            updater();
          } else {
            Swal.fire("مشکلی در حذف آیتم پیش آمده است");
          }
        });
      }
    });
  }
  return (
    <>
      <div className="card-item-tabs d-flex flex-wrap digits" id={information.id}>
        <div>
          <div className="title">کاربر</div>
          {information.user && <div className="description">{information.user.fullname}</div>}
        </div>
        <div>
          <div className="title">مبلغ</div>
          <div className="description  ">{addCommas(information.price)}</div>
        </div>
        <div>
          <div className="title">زمان ثبت</div>
          <div className="description">{information.time}</div>
        </div>
        <div>
          <div className="title">تاریخ انجام</div>
          <div className="description">{information.date}</div>
        </div>

        <div>
          <div className="title">نوع</div>
          <div className="description">
            {information.type == 1 && "واریز"}
            {information.type == 2 && "تراکنش داخلی"}
            {information.type == 3 && "برداشت"}
          </div>
        </div>
        <div>
          <div className="title">عملیات</div>
          <div className="description d-flex icon-container justify-content-between align-items-center">
            <div
              className=" me-2"
              data-bs-toggle="modal"
              data-bs-target="#edit-card-item"
              onClick={() => {
                setCurrentTransactionInModal(information);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="17" viewBox="0 0 30 30" className="mt-0">
                <path id="Icon_awesome-edit" data-name="Icon awesome-edit" d="M20.969,4.877l4.7,5.286a.625.625,0,0,1,0,.809l-11.375,12.8-4.833.6a1.081,1.081,0,0,1-1.12-1.26l.536-5.439L20.25,4.877A.47.47,0,0,1,20.969,4.877Zm8.438-1.342L26.865.675a1.881,1.881,0,0,0-2.875,0L22.146,2.75a.625.625,0,0,0,0,.809l4.7,5.286a.47.47,0,0,0,.719,0L29.406,6.77a2.5,2.5,0,0,0,0-3.235ZM20,20.29v5.966H3.333V7.5H15.3a.606.606,0,0,0,.443-.205l2.083-2.344a.717.717,0,0,0-.443-1.2H2.5A2.671,2.671,0,0,0,0,6.565V27.194a2.671,2.671,0,0,0,2.5,2.813H20.833a2.671,2.671,0,0,0,2.5-2.813V17.946a.62.62,0,0,0-1.068-.5l-2.083,2.344A.769.769,0,0,0,20,20.29Z" transform="translate(0 -0.007)" fill="#fff" />
              </svg>
            </div>
            <div
              className="me-2"
              onClick={() => {
                deleteCard(information.id, information.type);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" viewBox="0 0 21 27" className="mt-0">
                <path id="Icon_material-delete" data-name="Icon material-delete" d="M9,28.5a3.009,3.009,0,0,0,3,3H24a3.009,3.009,0,0,0,3-3v-18H9ZM28.5,6H23.25l-1.5-1.5h-7.5L12.75,6H7.5V9h21Z" transform="translate(-7.5 -4.5)" fill="#fff" />
              </svg>
            </div>
          </div>
          <div className="description"></div>
        </div>
      </div>
    </>
  );
}
export function Searchbox({ search1 }) {
  return (
    <div className="search-box mt-3">
      <div className="magnifier">
        <svg xmlns="http://www.w3.org/2000/svg" width="20.621" height="20.621" viewBox="0 0 30.621 30.621">
          <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(-3 -3)">
            <path id="Path_211" data-name="Path 211" d="M28.5,16.5a12,12,0,1,1-12-12A12,12,0,0,1,28.5,16.5Z" fill="none" stroke="#8a3ffc" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
            <path id="Path_212" data-name="Path 212" d="M31.5,31.5l-6.525-6.525" fill="none" stroke="#8a3ffc" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
          </g>
        </svg>
      </div>
      <input
        type="text"
        className="form-control"
        placeholder="عبارت مورد نظر خود را جست و جو کنید"
        onChange={(e) => {
          return search1(e.target.value);
        }}
      />
    </div>
  );
}
